export default {
  title: 'Produse promovate',
};
